module.exports = __webpack_public_path__ + "img/issue-1.772d7f7d.svg";